export { CLINIC_SETUP_NAME_REGEX, CLINIC_SETUP_LINK_REGEX } from './clinicSetupValidation';
